import type { LoaderFunction } from "@remix-run/node";
import { json } from "@remix-run/node";

import { PublicSessionNotes } from "~/components/session-page/session-notes";
import { scheduleBackgroundTask, withCors } from "~/config/cors";
import { UploadProvider } from "~/context/UploadContext";
import { useUTMCapture } from "~/hooks/use-utm-capture";
import { logAnonymousPageView } from "~/modules.server/analytics/anonymous-page-view.server";
import { pageMeta } from "~/utils/meta";

export const meta = pageMeta(
    "Shared Session - Parts Companion",
    "View shared session notes",
);

// AIDEV-NOTE: Cold ad/Framer traffic lands here directly (the marketing site's
// "sample session" link), so anonymous visits are logged server-side like
// /landing — otherwise these landings are invisible to DB visit counts.
export const loader: LoaderFunction = withCors(async ({ request }) => {
    // AIDEV-NOTE: waitUntil-backed so Vercel can't suspend before the insert
    // lands; metadata.route keeps these rows countable without LIKE-matching
    // the per-session path (/sessions/<id>/sharing).
    scheduleBackgroundTask(
        logAnonymousPageView(request, {
            metadata: { route: "session-sharing" },
        }),
    );
    return json({});
});

export default function SessionSharingRoute() {
    // AIDEV-NOTE: Ad clicks arrive here with utm params intact; without capture
    // they are gone by the time the visitor reaches /signup and the signup is
    // mis-attributed to referrer app.partscompanion.org.
    useUTMCapture();

    return (
        <UploadProvider>
            <PublicSessionNotes />
        </UploadProvider>
    );
}
